(function () {
    'use strict';

    angular.module("imApp").factory("deviationService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 319,
                    parameters: parms || {}
                });
            },
            listOnlyDeviations: function (parms) {
                return $ihttp.post({
                    method: 1134,
                    parameters: parms || {}
                });
            },
            listOrderLines: function (parms) {
                return $ihttp.post({
                    method: 470,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 152,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 136,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
